import { token } from '@zillow/constellation';
import styled from 'styled-components';

export const MobileDropdownMenuSectionContainer = styled.li`
    border-bottom: 1px solid ${token('colors.borderLight')};
`;
